<template>
  <div class="philosophy-section">
    <SectionTitle heading="Explore Words" />
    <div class="our-philosophy-contents">
      <button class="quotation-button" :class="{ 'click-animation': isClicked, 'longclick-animation': isLongClicked }"
        @mousedown="startPress" @mouseup="endPress" @mouseleave="cancelPress" @touchstart="startPress"
        @touchend="endPress" @touchcancel="cancelPress">
        ”
      </button>
      <div class="quote-wrapper">
        <transition name="fade">
          <div v-if="currentQuote" :key="currentQuote?.id">
            <p class="p-quotes" v-html="formatText(currentQuote?.text)"></p>
            <p class="p-author_book">
              —————— <span>{{ currentQuote?.author }}</span>『<span>{{ currentQuote?.book_title }}</span>』
            </p>
          </div>
        </transition>
        <!-- 長押しで全件取得 -->
        <ul v-if="allQuotes.length > 0">
          <transition-group name="fade" tag="ul">
            <li class="li-nagaoshi" v-for="quote in allQuotes" :key="quote.quote_id">
              <p class="p-quotes" v-html="formatText(quote.text)"></p>
              <p class="p-author_book">
                —————— <span>{{ quote.author }}</span>『<span>{{ quote.book_title }}</span>』
              </p>
            </li>
          </transition-group>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SectionTitle from "@/features/about/components/SectionTitle.vue";
export default {
  components: {
    SectionTitle,
  },
  data() {
    return {
      currentQuote: null, // 現在の引用
      allQuotes: [], // 全引用リスト

      isClicked: false, // クリックアニメーション用
      isLongClicked: false, // ダブルクリックアニメーション用

      pressTimer: null,
      isLongPress: false,
    };
  },
  methods: {
    startPress() {
      this.isLongPress = false;

      // 長押しのタイマーを設定
      this.pressTimer = setTimeout(() => {
        this.isLongPress = true;
        this.longPressAction();
      }, 1800);
    },
    endPress() {
      clearTimeout(this.pressTimer);

      // 長押しの場合はクリック処理をスキップ
      if (this.isLongPress) {
        this.isLongPress = false; // 状態をリセット
        return;
      }

      this.clickAction();
    },
    cancelPress() {
      clearTimeout(this.pressTimer);
    },

    clickAction() {
      this.isClicked = true;
      this.currentQuote = null;
      this.fetchNextQuote();
      setTimeout(() => {
        this.isClicked = false;
      }, 300); // アニメーション時間に合わせてリセット
      this.allQuotes = []
    },
    longPressAction() {
      this.isLongClicked = true;
      this.fetchAllQuotes();
      setTimeout(() => {
        this.isLongClicked = false;
      }, 1000); // アニメーション時間に合わせてリセット
      this.currentQuote = null; // 全件取得時はランダムデータをリセット
    },

    async fetchNextQuote() {
      const RANDOM_QUOTE_API = process.env.VUE_APP_API_URL_FETCH_ONE_QUOTE;
      try {
        const response = await axios.get(RANDOM_QUOTE_API);
        this.currentQuote = response.data;
      } catch (error) {
        console.error("Error fetching next quote:", error);
      }
    },
    async fetchAllQuotes() {
      const ALL_QUOTES_API = process.env.VUE_APP_API_URL_FETCH_ALL_QUOTES;
      try {
        const response = await axios.get(ALL_QUOTES_API);
        this.allQuotes = response.data;
      } catch (error) {
        console.error("Error fetching all quotes:", error);
      }
    },

    // 改行を <br> に変換
    formatText(text) {
      return text ? text.replace(/\n/g, "<br>") : "";
    },
  },
  created() {
    this.fetchNextQuote()
  },
};
</script>

<style scoped>
.philosophy-section {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.our-philosophy-contents {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 100px;
}

/* クリック時のアニメーション */
.click-animation {
  animation: clickEffect 0.2s ease-in-out forwards;
}

@keyframes clickEffect {
  0% {
    background-color: #dfefee;
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
    background-color: transparent;
  }
}

/* ダブルクリック時のアニメーション */
.longclick-animation {
  animation: longClickEffect 1.8s ease-in forwards;
}

@keyframes longClickEffect {
  0% {
    transform: scale(1.3);
    background-color: #ceece8;
  }

  100% {
    transform: scale(1);
    background-color: transparent;
  }
}

.quotation-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  width: 65px;
  height: 65px;
  border: transparent;
  background-color: transparent;
  color: #003633;
  box-shadow: rgba(101, 141, 153, 0.15) 0px 5px 30px 0px;
  margin-bottom: 30px;
  font-family: "GenEiKoburiMin";
  font-size: 40px;
  font-weight: bolder;
  border-radius: 100%;
  cursor: pointer;
  user-select: none;
  /* テキスト選択を無効化 */
  -webkit-user-select: none;
  /* Safari対応 */
  -ms-user-select: none;
  /* 旧IE対応 */
  -webkit-tap-highlight-color: transparent;
  /* スマホでのタップ時のハイライトを無効化 */
}


.quote-wrapper {
  min-height: 300px;
}

.p-quotes {
  height: auto;
  font-family: "GenEiKoburiMin";
  font-size: 14px;
  color: #493c33;
  line-height: 1.5rem;
  text-align: start;
  margin-bottom: 50px;
  max-width: 900px;
}

.p-author_book {
  width: auto;
  height: auto;
  font-family: "GenEiKoburiMin";
  font-size: 13px;
  color: #493c33;
  text-align: end;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.li-nagaoshi {
  list-style: none;
  padding-left: 0%;
  margin-bottom: 200px;
}

@media screen and (max-width: 1024px) {

  .quotation-button {
    width: 70px;
    height: 70px;
    margin-top: 50px;
    margin-bottom: 0px;
    padding-top: 10px;
    font-size: 30px;
  }

}

@media screen and (max-width: 570px) {

  .philosophy-section {
    row-gap: 30px;
  }

  .our-philosophy-contents {
    row-gap: 50px;
  }

  .quote-wrapper {
    margin-top: 40px;
    min-height: 200px;
  }


  .quotation-button {
    width: 65px;
    height: 65px;
    margin-bottom: 0px;
    padding-top: 10px;
    font-size: 20px;
  }

  .p-quotes {
    font-size: 12px;
    line-height: 1.5rem;
  }

  .p-author_book {
    font-size: 12px;
  }

  .our-philosophy-contents ul {
    padding: 0%;
  }

  .li-nagaoshi {
    margin-bottom: 100px;
  }

}
</style>